<template>
    <b-card :header="uLang('app.bow_export')" header-tag="h4" class="bg-default-card">
        <form
            @submit.prevent="onSubmit"
        >
            <form-group name="start-date" :label="uLang('app.start_date')">
                <vue-pikaday
                    id="start-date"
                    v-model="formData.start_date"
                    :options="pickerOptions"
                    :required="true"
                    class="form-control"
                    autocomplete="off"
                />
            </form-group>

            <form-group name="end-date" :label="uLang('app.end_date')">
                <vue-pikaday
                    id="end-date"
                    v-model="formData.end_date"
                    :options="pickerOptions"
                    :required="true"
                    class="form-control"
                    autocomplete="off"
                />
            </form-group>

            <backend-select
                v-model="formData.status"
                :close-on-select="false"
                :route="route('trajectory-enrolment-statuses.index')"
                object-name-key="translated_name"
                return="id"
                name="status"
                multiple
            />

            <div class="form-group fr-absolute">
                <input
                    type="submit"
                    class="btn btn-brand"
                    :disabled="busy"
                    :value="uLang('app.export')"
                />
            </div>
        </form>
    </b-card>
</template>

<script>
    import { FormGroup } from "~/Form/elements";
    import { PikadayOptions } from '~/Form/elements'
    import { FileDownload } from "~/mixins"

    export default {
        name: 'BowReport',
        mixins: [ FileDownload ],
        components: {
            'form-group': FormGroup
        },
        data() {
            return {
                busy: false,
                pickerOptions: PikadayOptions,
                formData: {
                    start_date: null,
                    end_date: null,
                    status: null,
                }
            }
        },
        methods: {
            async onSubmit() {
                this.busy = true;
                axios.post(
                    route('reports.bow-export'),
                    {
                        start_date: moment(this.formData.start_date).format('YYYY-MM-DD'),
                        end_date: moment(this.formData.end_date).format('YYYY-MM-DD'),
                        status_id: typeof this.formData.status !== 'undefined' && this.formData.status !== null ?
                            this.formData.status.map(status => status) :
                            null
                    },
                    {
                        responseType: 'blob'
                    }
                ).then((response) => {
                    this.downloadFile(response);
                    this.busy = false;
                }).catch((e) => {
                    this.busy = false;
                });
            }
        }
    }
</script>

